<template>
    <div id="myinfo-nationality">
      <f7-list form class="form-group">
        <f7-list-input
            input-id      ="nationality"
            id            ="nationalityInput"
            name          ="nationality"

            class         ="clickable-row use-chevron"
            placeholder   =""
            :value        ="nationality"
            :label        ="$t('regis-nationality')"
            autocomplete  ="off"
            v-show        ="isShow"
            :disabled    = "isDisabled"
            outline
            floating-label
            required
          >
            <f7-link no-link-class popover-open=".popover-dropdown-nationality" slot="content-start" class="clickable-item"></f7-link>
          </f7-list-input>

          <f7-popover id="dropdownNationality" class="popover-dropdown-nationality dropdown-default dropdown myinfo" vertical-position="bottom" :backdrop="true">
              <f7-list>
                  <f7-list-item popover-close link="#" v-for="n in nationalityList" :key="n.countryId"  @click="onInput('nationality', {id: n.countryId, name: n.countryName})">
                      {{n.countryName}}
                  </f7-list-item>
              </f7-list>
          </f7-popover>

    </f7-list>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      isShow:{
        type: Boolean
      },
      isDisabled:{
        type: Boolean
      },
      nationalityList: {
        type: Array
      }
    },
    mounted (){
      this.renderDropdown();
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('myinfo', [
          'nationalityId',
          'nationality'
      ])
    },
    methods: {
      ...mapActions('myinfo', [
          'setNationality',
          'validateInput',
      ]),

      async renderDropdown(){
        const self    = this;
        const popover = ".myinfo.popover-dropdown-nationality";
        const popoverInner = ".myinfo.popover-dropdown-nationality .popover-inner";
        const popoverId = "dropdownNationality";
        const inputId = "nationality";
        const inputListId = "#nationalityInput";
        await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)
      },

      async onInput(id, val){
        await this.setNationality({id: val.id, name: val.name});
        await this.validateInput({id: id, value:val.id});
        this.validateNextButton()
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }
    }
  }
</script>